// Identifiants des rôles (cf. yom-api/src/constants/roles.js)
export const ROLES = Object.freeze({
    ADMIN: 1,
    PRESTATAIRE: 2,
    CLIENT: 3,
    SUPER_ADMIN: 4,
});
